import { render } from "./PlaygroundQuestion.vue?vue&type=template&id=63c1c590"
import script from "./PlaygroundQuestion.vue?vue&type=script&lang=js"
export * from "./PlaygroundQuestion.vue?vue&type=script&lang=js"

import "./PlaygroundQuestion.vue?vue&type=style&index=0&id=63c1c590&lang=scss"
script.render = render

export default script